module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/3q36QAaZA38WcWKX1lV6A4-fe8bb3cf9e25f35b7b518d9d69d9b1df.jpg";